import { IActionItem } from '@components/ActionsMenu/types';
import { useUiChromeActions } from '@components/MainStage/uiChrome.store';
import { useProject } from '@context/Project/ProjectProvider';
import useResetViewport from '@hooks/canvas/useResetViewport';
import { themePalette } from '@theme/muiTheme';
import { ShowHideUiIcon } from '@utils/iconsDefs';

export const SHOW_HIDE_UI_LABEL = 'Show/Hide UI';

const CHROME_TRANSITION_MS = 225;

const useShowHideUiItem = (onClose: () => void): IActionItem[] => {
  const { drawer } = useProject();
  const { toggle } = useUiChromeActions();
  const resetViewPort = useResetViewport();

  if (drawer) return [];

  return [
    {
      icon: <ShowHideUiIcon fill={themePalette.grey[800]} />,
      text: SHOW_HIDE_UI_LABEL,
      color: 'grey.1000',
      onClick: () => {
        onClose();
        toggle();
        resetViewPort(CHROME_TRANSITION_MS);
      },
    },
  ];
};

export default useShowHideUiItem;
